// /rf-admin/me — 改密(M1 change-password 已实现,前端页面)
// UI 复刻 /dashboard:Card + PageTitle + .field + .input + .btn-primary

import { useState } from "react";
import { rfAdminChangeMyPassword } from "../api/admin";
import { Card } from "../../components/ui/Card";
import { PageTitle } from "../../components/ui/PageTitle";
import { Button } from "../../components/ui/Button";

export function RfAdminMe() {
  const [old, setOld] = useState("");
  const [new1, setNew1] = useState("");
  const [new2, setNew2] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    if (new1 !== new2) {
      setError("新しいパスワードが一致しません");
      return;
    }
    setSubmitting(true);
    try {
      await rfAdminChangeMyPassword(old, new1);
      setDone(true);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="rf-admin-page">
      <PageTitle
        title="パスワード変更"
        subtitle="現在の管理者パスワードを変更します。"
      />
      <Card>
        {done ? (
          <div className="rf-admin-success">変更しました。次回ログイン時から新しいパスワードを使用してください。</div>
        ) : (
          <form onSubmit={onSubmit} className="rf-admin-form">
            <div className="field">
              <label htmlFor="old-pw" className="field-label">
                現在のパスワード <span className="field-label-required">*</span>
              </label>
              <input
                id="old-pw"
                type="password"
                className="input"
                value={old}
                onChange={(e) => setOld(e.target.value)}
                required
              />
            </div>

            <div className="field">
              <label htmlFor="new-pw-1" className="field-label">
                新しいパスワード <span className="field-label-required">*</span>
              </label>
              <input
                id="new-pw-1"
                type="password"
                className="input"
                value={new1}
                onChange={(e) => setNew1(e.target.value)}
                required
                minLength={12}
              />
              <div className="field-hint">12文字以上、大小英字・数字・記号を含む</div>
            </div>

            <div className="field">
              <label htmlFor="new-pw-2" className="field-label">
                新しいパスワード(確認) <span className="field-label-required">*</span>
              </label>
              <input
                id="new-pw-2"
                type="password"
                className="input"
                value={new2}
                onChange={(e) => setNew2(e.target.value)}
                required
              />
            </div>

            {error && <div className="login-error">{error}</div>}

            <div className="row" style={{ marginTop: 8 }}>
              <Button type="submit" variant="primary" disabled={submitting}>
                {submitting ? "変更中..." : "変更する"}
              </Button>
            </div>
          </form>
        )}
      </Card>
    </div>
  );
}
